<template>
  <div class="cartao_credito" :class="config.front ? '': 'cartao_credito_flip'" v-if="card != null && config != null">
    <div class="cartao_credito_front" :style="'color: #FFF; background: '+ config.primary_color + '; background: linear-gradient(124deg, ' + config.primary_color + ' 0%, ' + config.secondary_color + ' 100%);'">
      <div class="cartao_credito_pattern"></div>
      <div class="cartao_credito_bandeira"><v-img :src="config.image" :alt="config.name" eager v-if="config.image != '' && config.image != null && config.image != undefined && config.image != 'no-image'"></v-img></div>
      <div class="cartao_credito_numero" :class="config.background != '' ? 'text-shadow': ''">{{ card.number != null ? mascaraCartao(card.number): "**** **** **** ****" }}</div>
      <div class="cartao_credito_nome"><span class="nome" :class="config.background != '' ? 'text-shadow': ''">{{ card.name != "" ? card.name.substring(0, 20) : "NOME DO TITULAR" }}</span> <span class="cartao_credito_data" :class="config.background != '' ? 'text-shadow': ''">{{ card.valid != null ? mascaravalid(card.valid): "MM/AA" }}</span></div>
    </div>
    <div class="cartao_credito_back" :style="'color: #FFF; background: '+ config.primary_color + '; background: linear-gradient(124deg, ' + config.primary_color + ' 0%, ' + config.secondary_color + ' 100%);'">
      <div class="cartao_credito_pattern"></div>
      <div class="cartao_credito_faixa"></div>
      <div class="cartao_credito_seg_circle"></div>
      <div class="cartao_credito_seg">{{ card.cvv != null ? card.cvv : "***" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCard',
  props: {
    card: {
      type: Object,
      default: null
    },
    config: {
      type: Object,
      default: null
    },
  },
  computed: {
    img_logo(){
      return new URL('../assets/images/'+this.config.flag+'.png', import.meta.url).href;
    }
  },
  methods: {
    mascaraCartao(value){
      value = value.replace(/\D/g, '').padEnd(this.config.min_lenght, "*");
      if(this.config.min_lenght == 14){
        value = value.substring(0, 4) + " " + value.substring(4, 10) + " " + value.substring(10, 14);
      } else if(this.config.min_lenght == 15){
        value = value.substring(0, 4) + " " + value.substring(4, 10) + " " + value.substring(10, 15);
      } else {
        value = value.substring(0, 4) + " " + value.substring(4, 8) + " " + value.substring(8, 12) + " " + value.substring(12, 16);
      }
      return value;
    },
    mascaravalid(value){
      value = value.replace(/\D/g, '').padEnd(4, "*");
      value = value.substring(0, 2) + "/" + value.substring(2, 4);
      return value;
    },
  }
}
</script>